import { IAlfredServiceApis } from "./IAlfredServiceApis"
import ApiUtils from "../ApiUtils"
import { IBookConsultationRequest, IBookConsultationResponse } from "../../interfaces/api/alfred/IBookConsultation"
import { BookConsultationRequest, BookConsultationResponse } from "../../interfaces/api/alfred/bookConsultation"
import { IBookDiagnosticPayload } from "../../interfaces/api/alfred/bookDiagnostics"
import { AppTenants } from "../../constants"

const AlfredUrls = {
	getAddress: (userId: string) => `/address/user/${userId}`,
	createOrder: "/user/createOrder",
	createInternalOrder: "/user/internal/createOrder",
}
class AlfredServiceApis implements IAlfredServiceApis {
	getServiceUrl = (url: string) => "/alfred" + url
	getUserAddresses(userId: string) {
		const url = this.getServiceUrl(AlfredUrls.getAddress(userId))
		return ApiUtils.get(url)
	}

	bookConsultation(payload: BookConsultationRequest, headers?: any): Promise<BookConsultationResponse> {
		// add tenant in payload
		const tenant = payload.tenant ? payload.tenant : AppTenants.SUGARFIT
		const updatedPayload = { ...payload, tenant: tenant.toLowerCase() }
		return ApiUtils.post(this.getServiceUrl(AlfredUrls.createOrder), updatedPayload, headers)
	}

	bookDiagnostics(payload: IBookDiagnosticPayload, headers?: any): Promise<any> {
		// add tenant in payload
		const tenant = payload.tenant ? payload.tenant : AppTenants.SUGARFIT
		const updatedPayload = { ...payload, tenant: tenant.toLowerCase() }
		return ApiUtils.post(this.getServiceUrl(AlfredUrls.createInternalOrder), updatedPayload, headers)
	}

	// getUserAddressById(addressId: string): Promise<any> {
	// 	const url = this.getUrl(`/address/${addressId}`);
	// 	return ApiUtils.apiGetRequest(url);
	// }
	//
	// public confirmBookingPayment(orderId: number | string, amount: number, mode: "CASH", isCurefitUser?: boolean): Promise<any> {
	// 	const payload: any = {
	// 		gatewayOrderId: null,
	// 		paymentData: {
	// 			gatewayId: null,
	// 			paymentId: "",
	// 			channel: "MANUAL",
	// 			amount,
	// 			currency: "INR",
	// 			status: "paid",
	// 			data: {
	// 				mode,
	// 				transactionId: null,
	// 				isCurefitUser: !!isCurefitUser,
	// 				bookingLead: null,
	// 				transactionDate: moment().toISOString(),
	// 			},
	// 		},
	// 	};
	// 	return ApiUtils.apiPostRequest(this.getUrl(`/user/paymentSuccess/${orderId}`), JSON.stringify(payload));
	// }
	//
	// private getUrl(path: string) {
	// 	return ApiUtils.createApiUrl("/alfred" + path);
	// }
}

export default AlfredServiceApis
